import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { cities } from 'src/app/shared/models/cities';
import { BankDetail } from 'src/app/shared/models/clients/bankDetail';
import { Client } from 'src/app/shared/models/clients/client';
import { Contact } from 'src/app/shared/models/clients/contact';
import { Partner } from 'src/app/shared/models/clients/partner';
import { countries } from 'src/app/shared/models/countries';
import { Service } from 'src/app/shared/models/services/service';
import { BankDetailsModalComponent } from '../bank-details-modal/bank-details-modal.component';
import { ContactModalComponent } from '../contact-modal/contact-modal.component';
import { UploadDocumentModalComponent } from '../upload-document-modal/upload-document-modal.component';
import { ClientContract, PaymentPlanEnum } from 'src/app/shared/models/clients/clientContract';
import { PartnersModalComponent } from '../partners-modal/partners-modal.component';
import { NewFileService } from 'src/app/core/services/new-file.service';
import { Case } from 'src/app/shared/models/cases/case';
import { CaseClient } from 'src/app/shared/models/cases/caseClient';
import { NgSelectProps } from 'src/app/shared/models/ng-select-props';
import { LawyersApiService } from 'src/app/core/services/api/lawyers-api.service';
import { ConfirmModalComponent } from 'src/app/shared/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-create-new-client',
  templateUrl: './create-new-client.component.html',
  styleUrls: ['./create-new-client.component.scss']
})
export class CreateNewClientComponent implements OnInit {
  public client: Client = new Client();
  public contract: ClientContract = new ClientContract();
  files: File[] = [];
  services: Service[] = [];
  countries = countries;
  cities = cities;
  paymentPlanEum = PaymentPlanEnum;
  @ViewChild('acc') accordian: NgbAccordion;
  @ViewChild('contactModal') contactModal: ContactModalComponent;
  @ViewChild('partnerModal') partnerModal: PartnersModalComponent;
  @ViewChild('bankDetailsModal') bankDetailsModal: BankDetailsModalComponent;
  @ViewChild('uploadDocModal') uploadDocModal: UploadDocumentModalComponent;
  @ViewChild('confirmModal') confirmModal: ConfirmModalComponent;


  public lawyerNgSelect = null;


  constructor(
    private apiService: ClientsApiService,
    private lawyerApi: LawyersApiService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private newFileService: NewFileService,
    private router: Router
  ) {
    this.route.data.subscribe(resolverData => {
      this.services = resolverData.services.results;
    });
  }

  ngOnInit(): void {
    this.lawyerNgSelect = new NgSelectProps(this.lawyerApi.getLawyers);

  }

  submitClient() {
    this.spinner.show();
    if (this.client.id) {
      this.apiService.updateClient(this.client).subscribe(
        c => {
          this.client = c;
          this.spinner.hide();
          this.toastr.success('Client updated.', 'Success!');
          this.accordian.toggle('contract');
        }
      )
    } else {
      this.apiService.createClient(this.client).subscribe(
        c => {
          this.client = c;
          this.contract.clientId = c.id;
          this.spinner.hide();
          this.toastr.success('Client created.', 'Success!');
          this.accordian.toggle('contract');
        }
      )
    }
  }

  deleteClient() {
    this.confirmModal.open(`Are you sure you want to delete this client?`, () => {
      this.confirmModal.close();
      if (this.client.id) {
        this.spinner.show();
        this.apiService.deleteClient(this.client).subscribe(r => {
          this.spinner.hide();
        })
      }
      this.client = new Client();
      this.toastr.success(`Client was Deleted`, 'Success!');
    });
  }

  SubmitContract(contract: ClientContract) {
    this.spinner.show();
    this.apiService.createClientContract(this.client.id, contract).subscribe(
      c => {
        this.spinner.hide();
        this.accordian.toggle('partners');
        this.client.contract = contract;
        this.toastr.success(`contract created`, 'Success!');
      }
    )
  }


  // Partners
  addNewPartner() {
    const partner = new Partner();
    partner.clientId = this.client.id;
    this.partnerModal.open(partner);
  }

  editPartner(partner: Partner) {
    this.partnerModal.open(partner);
  }

  partnerSubmit(partner: Partner) {
    let action = '';
    if (this.client.notes.find(n => partner.id === n.id)) {
      const i = this.client.partners.indexOf(partner);
      this.client.partners[i] = partner;
      action = 'updated';
    } else {
      this.client.partners.push(partner);
      action = 'created';
    }
    this.toastr.success(`Partner ${action}`, 'Success!');
  }

  // Primary Contacts
  addNewContact() {
    const contact = new Contact();
    contact.clientId = this.client.id;
    this.contactModal.open(contact);
  }

  editContact(contact: Contact) {
    this.contactModal.open(contact);
  }

  contactSubmit(contact: Contact) {
    let action = '';
    if (this.client.notes.find(n => contact.id === n.id)) {
      const i = this.client.contacts.indexOf(contact);
      this.client.contacts[i] = contact;
      action = 'updated';
    } else {
      this.client.contacts.push(contact);
      action = 'created';
    }
    this.contactModal.close();
    this.toastr.success(`Contact ${action}`, 'Success!');
  }

  // bank account
  addNewBank() {
    const bankDetail = new BankDetail();
    bankDetail.clientId = this.client.id;
    this.bankDetailsModal.open(bankDetail);
  }

  editbank(bankDetail: BankDetail) {
    this.bankDetailsModal.open(bankDetail);
  }

  bankDetailSubmit(bankDetail: BankDetail) {
    let action = '';
    if (this.client.notes.find(n => bankDetail.id === n.id)) {
      const i = this.client.bankDetails.indexOf(bankDetail);
      this.client.bankDetails[i] = bankDetail;
      action = 'updated';
    } else {
      this.client.bankDetails.push(bankDetail);
      action = 'created';
    }
    this.bankDetailsModal.close();
    this.toastr.success(`Bank Account ${action}`, 'Success!');
  }

  // Document
  // handle file uploading
  onSelectDoc(event) {
    this.files.push(...event.addedFiles);
  }

  onRemoveDoc(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  onSubmitDocument() {
    this.spinner.show();
    const formData = new FormData();
    this.files.forEach((val, index, arr) => {
      formData.append('document', arr[index]);
    });
    this.apiService.uploadFileDocument(this.client.id, formData).subscribe(
      r => {
        this.spinner.hide();
        this.toastr.success(`Files uploaded`, 'Success!');
        this.accordian.toggle('newFile');
      }
    )
  }

  addNewFile() {
    if (this.client.id) {
      const caseClient = new CaseClient();
      caseClient.clientId = this.client.id;
      caseClient.client = this.client;
      this.newFileService.file = new Case();
      this.newFileService.file.clients.push(caseClient);
      this.router.navigate(['/files/new'], { relativeTo: this.route });
    }
  }

  searchFn() {
    return true;
  }
}
